import { useFeedbackModalContext } from '../context/FeedbackModalContext';

/**
 * Hook global para invocar carteles de feedback (éxito, error, advertencia, confirmación, pregunta e información).
 * Permite invocación declarativa o imperativa mediante promesas (async/await).
 *
 * @example
 * const { showSuccess, showError, showWarning, showConfirm, showQuestion, showInfo } = useFeedbackModal();
 *
 * await showSuccess({
 *   title: '¡Nota Registrada Exitosamente!',
 *   detail: { text: 'Se ha enviado un correo a', highlight: 'correo@ejemplo.com', suffix: 'con los detalles.' },
 *   confirmText: 'Aceptar'
 * });
 */
const useFeedbackModal = () => {
  return useFeedbackModalContext();
};

export default useFeedbackModal;
